import './PrivacyPolicy.css';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Container from '@mui/material/Container';

import En from './__en';
import Vi from './__vi';
import Ja from './__ja';


function PrivacyPolicy(props) {
    const { translate, Intl } = props;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div className='privacy-policy'>
            <Container maxWidth="xl" sx={{ my: 20 }}>
                {Intl.locale === 'en' && <En />}
                {Intl.locale === 'vi' && <Vi />}
                {Intl.locale === 'ja' && <Ja />}
            </Container>
        </div>
    );
}
function mapStateToProps(state) {
    return {
      Intl: state.Intl,
    }
}
export default connect(mapStateToProps)(PrivacyPolicy);